import React from "react";
import { Modal } from "antd";

function SmallModal({
  text,
  isPriceModalVisible,
  setIsPriceModalVisible,
  width,
}) {
  return (
    <Modal
      visible={isPriceModalVisible}
      onOk={() => setIsPriceModalVisible(false)}
      onCancel={() => setIsPriceModalVisible(false)}
      footer={null}
      // title="&nbsp;"
      title={null}
      width="auto"
      style={{ maxWidth: width || "400px", height: "300px" }}
      closable={false}
    >
      <div style={{ textAlign: "center", margin: 10 }}>
        <div
          style={{
            margin: "10px 20px 16px 26px",
            paddingTop: 16,
            fontSize: "1rem",
          }}
        >
          {text}
        </div>
        <button
          type="button"
          className="ahp-button"
          onClick={() => {
            setIsPriceModalVisible(false);
          }}
          style={{ marginBottom: 16 }}
        >
          OK
        </button>
      </div>
    </Modal>
  );
}

export default SmallModal;
